import { render } from "./InfoCardTab.vue?vue&type=template&id=680ad9f4"
import script from "./InfoCardTab.vue?vue&type=script&lang=js"
export * from "./InfoCardTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__